import { render, staticRenderFns } from "./otherexpenses.vue?vue&type=template&id=114870e4"
import script from "./otherexpenses.vue?vue&type=script&lang=js"
export * from "./otherexpenses.vue?vue&type=script&lang=js"
import style0 from "./otherexpenses.vue?vue&type=style&index=0&id=114870e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports